/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Kind_PromoInputs */

const vi_shop_home_kind_promo = /** @type {(inputs: Shop_Home_Kind_PromoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối khuyến mãi`)
};

/**

* @param {Shop_Home_Kind_PromoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_kind_promo = /** @type {((inputs?: Shop_Home_Kind_PromoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Kind_PromoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_kind_promo(inputs)
});